<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13vdYZn/tc-custom/9781504089906.jpg?1718106414253" alt="This image is the cover for the book Return of Mr. Campion, The Albert Campion Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Return of Mr. Campion, The Albert Campion Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of thirteen short stories brings back an acclaimed Golden Age mystery author’s beloved sleuth, as well as a host of fresh characters and genres.</b><br/><br/>Margery Allingham fans will delight at being reunited with the Queen of Crime’s most thrilling detective, Albert Campion. From capers and traditional mysteries to slice-of-life stories, romantic tales, and even a Christmas story, this anthology is a must-have for Allingham enthusiasts, as well as readers who have yet to discover the esteemed English author.<br/><br/><b>Praise for Margery Allingham</b><br/><br/>“Margery Allingham stands out like a shining knight.” —Agatha Christie<br/><br/>“My very favourite of the four Queens of crime is Allingham.” —J.K. Rowling<br/><br/>“Margery Allingham deserves to be rediscovered.” —P.D. James<br/><br/>“Spending an evening with Campion is one of life’s pure pleasures.” —<i>The Sunday Times</i><br/><br/>“Startlingly good.” —<i>The Guardian</i><br/><br/>“At once exciting and amusing.” <i>—The New York Times</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margery Allingham
      </h2>
      
      <p class="authorDescription body article">Margery Allingham, born in 1904 to Emily and Herbert Allingham, was an esteemed English novelist, author, and editor of <I>Christian Globe</I> and the <I>New London Journal</I>. Considered one of the four &ldquo;Queens of Crime&rdquo; from the golden age of detective fiction, Allingham began writing stories and plays at a young age and published her first novel, <I>Blackkerchief Dick</I>, at 19. She later studied drama and speech training at Regent Street Polytechnic in London. Allingham is best known for her character Albert Campion, a sleuth first introduced in <I>The Crime of Black Dudley</I>. Campion was featured in seventeen subsequent novels, and even more short stories. Allingham continued to write until her death on June 30, 1966.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Agora Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e93c597a